import { Component, Input } from '@angular/core';
import { FormGroup } from '@angular/forms';

@Component({
    selector: 'itpx-happy-input-template',
    templateUrl: './happy-input-template.component.html',
    styleUrls: ['./happy-input-template.component.css', '../styles.css'],
})
export class HappyInputTemplateComponent {

    @Input() controlName: string;
    @Input() form: FormGroup;
    @Input() required = true;

    constructor() {
    }

    get hasError() {
        const { form, controlName } = this;
        const control = form && form.controls[controlName];
        return control && control.errors && control.touched && control.dirty;
    }
}



// WEBPACK FOOTER //
// ./src/app/phoenix2/common/components/happy-template-input/happy-input-template.component.ts